import { createContext, useContext } from 'react';

export const DEFAULT_CANVAS_THEME = {
  colors: {
    background: '#ffffff',
    foreground: '#0b0b0e',
    primary: '#5b6cff',
    muted: '#6b7280',
  },
  fontFamily: 'Inter, system-ui, sans-serif',
  mode: 'light',
};

const CanvasThemeContext = createContext(DEFAULT_CANVAS_THEME);

export function CanvasThemeProvider({ value, children }) {
  const merged = {
    ...DEFAULT_CANVAS_THEME,
    ...(value || {}),
    colors: { ...DEFAULT_CANVAS_THEME.colors, ...((value && value.colors) || {}) },
  };
  return (
    <CanvasThemeContext.Provider value={merged}>{children}</CanvasThemeContext.Provider>
  );
}

export function useEditorTheme() {
  return useContext(CanvasThemeContext);
}
